<template>
   <section>
    <div class="owl-carousel owl-theme-default hero-slider owl-nav-custom">
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl1})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login</router-link> 
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register">Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
        <!-- <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl2})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login </router-link> 
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div> -->
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl3})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="h3 text-primary mb-0">RGEA</p>
                    <h1>Home Owners Association</h1> -->
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login</router-link> 
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl4})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login</router-link> 
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl5})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login</router-link> 
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl6})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login </router-link>
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
        <div class="hero-slide bg-cover bg-center py-5 with-border-image" :style="{backgroundImage: `url(${carousel.backgroundUrl7})`}">
            <div class="container text-white py-5 index-forward">
                <div class="row">
                <div class="col-lg-12 text-center">
                    <!-- <p class="lead">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor.</p> -->
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/login">Login </router-link>
                    <b v-if="!isAuthorized"> | </b>
                    <router-link v-if="!isAuthorized" class="btn btn-outline-primary text-white" to="/register"> Sign Up</router-link>
                </div>
                </div>
            </div>
        </div>
    </div>
  </section> 
</template>
<script>

import backgroundUrl1 from '../../assets/png/sliderOnMain/1.jpg';
//import backgroundUrl2 from '../../assets/png/main-banner.png'; 
import backgroundUrl3 from '../../assets/png/sliderOnMain/3.jpg';
import backgroundUrl4 from '../../assets/png/sliderOnMain/KTP-169.jpg';
import backgroundUrl5 from '../../assets/png/sliderOnMain/KTP-154.jpg';
import backgroundUrl6 from '../../assets/png/sliderOnMain/6.jpg';
import backgroundUrl7 from '../../assets/png/sliderOnMain/7.jpg';


import '../../assets/js/front.js';

export default {
    data() {
        return {
           carousel:{
                backgroundUrl1,
                //backgroundUrl2,
                backgroundUrl3,
                backgroundUrl4,
                backgroundUrl5,
                backgroundUrl6,
                backgroundUrl7,  
           }, 
           isAuthorized:false,
        }
    },

    mounted(){
        if(localStorage.getItem('token') != null){
            this.isAuthorized = true;
        }
    },

}
</script>